export const LOCAL_STORAGE_KEYS = {
    theme: 'THEME'
};
